import { Injectable } from '@angular/core';
import { NotificationActions, NotificationActionsV2 } from '../shared/models/notification';
import { ContentData, DescriptionData, NotificationItemsData, TitleData } from 'desy-angular';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, EMPTY, timer } from 'rxjs';
import { expand, filter, map, switchMap, take, finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GeneralService {
    public spinnerVisible = false;
    

    private _notifications: NotificationActions[] = []; // inicializamos
    private _notificationsV2: NotificationActionsV2[] = [];
    
    get notifications(): NotificationActions[] {
        return this._notifications;
    }
    set notifications(notifications: NotificationActions[]) {
        this._notifications = notifications;
    }

    get notificationsV2(): NotificationActionsV2[] {
        return this._notificationsV2;
    }

    set notificationsV2(notificationsV2: NotificationActionsV2[]) {
        this._notificationsV2 = notificationsV2;
    }

    #showHeader = true;
    get showHeader() {
        return this.#showHeader;
    }
    set showHeader(showHeader: boolean) {
        this.#showHeader = showHeader;
    }

    clearNotifications() {
        this.notifications = [];
        if ('notificationsV2' in this) {
            (this as any).notificationsV2 = [];
        }
    }

    constructor(private sanitize: DomSanitizer, private http: HttpClient) { }

    onlyNumber(event: KeyboardEvent | ClipboardEvent): boolean {
        if (event.type === 'paste') {
            const clipboardEvent = event as ClipboardEvent;
            const value = clipboardEvent.clipboardData?.getData('text');
            if (value) {
                const number = Number(value);
                if (number < 1 || number.toString().length > 4) {
                    return false;
                }
            }
            return true;
        } else {
            const keyboardEvent = event as KeyboardEvent;
            const charCode = keyboardEvent.which ? keyboardEvent.which : keyboardEvent.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
        }
        return true;
    }

    toggleSpinner(show: boolean): void {
        this.spinnerVisible = show;
    }

    public createNotificationErr(err: any, message?: string | string[]): void {
        this.notifications = [];
        if (err?.error?.cdgoError && err?.error?.txtoError) {
            this.notifications.push(this.createNotification(err.error.txtoError, 'alert'));
        } else if (Array.isArray(message)) {
            message.forEach((msg) => {
                this.notifications.push(this.createNotification(msg, 'alert'));
            });
        } else if (message) {
            this.notifications.push(this.createNotification(message, 'alert'));
        } else {
            this.notifications.push(this.createNotification('Se ha producido un error no controlado', 'alert'));
        }
    }

    public createNotificationSuccess(message?: string | string[]): void {
        this.notifications = [];
        if (Array.isArray(message)) {
            message.forEach((msg) => {
                this.notifications.push(this.createNotification(msg, 'success'));
            });
        } else if (message) {
            this.notifications.push(this.createNotification(message, 'success'));
        } else {
            this.notifications.push(this.createNotification('Se ha producido un error no controlado', 'success'));
        }
    }

    public createValidationErrors(title: string, htmlMessage: string) {

        const notification: NotificationActionsV2 = {
            id: `notif-validation-${Date.now()}`,
            type: 'alert',
            open: true,
            dismissible: true,
            classes: 'c-notification c-notification--alert fixed-notification',
            headingLevel: 3,
            titleNotification: { text: title },
            description: { html: htmlMessage, },
            items: [],
            icon: {}
        };

        this._notificationsV2 = [notification];
        window.scroll(0, 0);
    }
    
    public createNotification(
        message: string,
        type: 'success' | 'info' | 'alert',
        id?: string,
        isDismissible: boolean = true
    ): NotificationActions {
        let classes = '';
        switch (type) {
            case 'success':
                classes = 'c-notification c-notification--success';
                break;
            case 'info':
                classes = 'c-notification c-notification--primary';
                break;
            case 'alert':
                classes = 'c-notification c-notification--alert';
                break;
        }
        window.scroll(0, 0);

        return {
            id: `notif-${type}-${id ?? (this.notifications ? this.notifications.length : '0')}`,
            open: true,
            title: {
                text: message,
                html: message,
            },
            type: type,
            dismissible: isDismissible,
            classes: classes,
        };
    }

   public pollProcessStatus(processId: string): Observable<any> {
    const pollingInterval = 3000; // cada 3 segundos

    return this.getProcessStatus(processId).pipe(
      expand((response: any) => {
        if (response.status === 202) {
          // Esperar un poco y volver a consultar
          return timer(pollingInterval).pipe(
            switchMap(() => this.getProcessStatus(processId))
          );
        }
        return EMPTY;
      }),
      filter((response: any) => response.status === 200),
      map((response: any) => response.body),
      take(1)
    );
  }

  getProcessStatus(processId: string): Observable<any> {
    const url = `${environment.urlCore}/request/${processId}`;
    return this.http.get<any>(url, { observe: 'response' });
  }
}
